/**
 * Shared post-login routing helpers (email + social flows).
 */

/**
 * Route each persona to its home surface. Dealers/installers and operations
 * have dedicated portals; sending them to the customer dashboard makes it
 * call customer-only APIs (/installations, /finance) that 403 for them.
 * Admins keep /dashboard (the /admin console needs a separate elevated
 * admin session).
 */
export function landingFor(role) {
  switch (role) {
    case 'dealer':
    case 'installer':
      return '/dealer'
    case 'operations':
      return '/operations'
    default:
      return '/dashboard'
  }
}

/**
 * Sanitize ?redirect= so login can only continue to an internal SPA path
 * (guards against open-redirect: must start with a single '/', never '//'
 * or a full URL). Returns null when absent/unsafe.
 */
export function safeRedirectTarget(route) {
  const raw = route.query.redirect
  const target = Array.isArray(raw) ? raw[0] : raw
  if (typeof target === 'string' && target.startsWith('/') && !target.startsWith('//')) {
    return target
  }
  return null
}
